import {testIds} from '@dms/routes';
import {DmsDataGrid, Main} from '@dms/shared';

import type {ActionCallback} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['urlDetail'] as const;

export function AuctionsList() {
  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    getColumnData,
  }) => {
    const urlDetail = getColumnData<string>('urlDetail')?.value;

    switch (actionKey) {
      case 'detail':
        if (!urlDetail) {
          return;
        }
        window.open(urlDetail, '_blank');
        return;
    }
  };

  return (
    <Main data-testid={testIds.vehicles.customers('page')} isFullHeight>
      <DmsDataGrid
        data-testid="quick-purchase"
        gridCode="vehicle-auction"
        predefinedColumns={PREDEFINED_COLUMNS}
        actionCallback={actionCallback}
      />
    </Main>
  );
}
